import { TouchableOpacity, View, StyleSheet, Platform } from "react-native";

import { Plan as PlanT } from "../../../../types/memberPlans";
import { useState } from "react";
import variables from "../../../../styles/variables";
import { useAtom } from "jotai";
import { openAuthModalAtom } from "../../../../atoms";
import RCorner from "../../../RCorner/RCorner";
import RText from "../../../RText";

import RButton from "../../../Buttons/RButton";
import { LinearGradient } from "expo-linear-gradient";
import { useResponsive } from "../../../../hooks/useResponsive";

const { colors } = variables;

export const Plan = ({
  id,
  name,
  currency = "£",
  description,
  payment_required,
  cost,
  payment_frequency_text,
  cta_button_text,
  show_lozenge,
  form_heading = undefined,
  form_sub_text = undefined,
  lozenge_box_colour,
  lozenge_text,
  lozenge_text_colour,
}: PlanT & { currency: "£" | "€" }) => {
  const { isSmallAndDown } = useResponsive();
  const [hover, setHover] = useState(false);
  const [_, setIsAuthModalOpen] = useAtom(openAuthModalAtom);

  const handleBgColor = () => {
    if (hover) return "#33324c";
    return colors.palette.rtv.primary;
  };

  return (
    <TouchableOpacity
      onPress={() => {
        setIsAuthModalOpen({
          id: id,
          name: name,
          cost: cost.toString(),
          plan_type: "normal",
          form_heading: form_heading,
          form_sub_text: form_sub_text,
        });
      }}
      // @ts-ignore
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={[styles.item]}
    >
      <View
        style={[
          styles.planContainer,
          {
            paddingTop: isSmallAndDown ? 6 : 12,
            borderColor: show_lozenge
              ? lozenge_box_colour
              : colors.palette.rtv.yellow,
            backgroundColor: handleBgColor(),
          },
        ]}
      >
        {show_lozenge ? (
          <LinearGradient
            colors={[handleBgColor(), lozenge_box_colour || "#FFC900"]} // gold → purple
            locations={[0.3, 0.9]} // dark fades by 70% of the way
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 1 }}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              borderRadius: 8,
            }}
          />
        ) : null}
        <View style={styles.planTopContainer}>
          <RText
            color={
              show_lozenge ? lozenge_box_colour : colors.palette.rtv.yellow
            }
            family="secondary"
            size={"xl"}
            lineHeight={32}
            weight="bold"
          >
            {name}
          </RText>
          <View style={{ display: "flex", flexDirection: "row", gap: 2 }}>
            <RText
              color="white"
              family="secondary"
              size={"xl"}
              lineHeight={32}
              weight="bold"
              uppercase
            >
              {`${currency}` + cost}
            </RText>
            <RText
              color="gray"
              family="primary"
              size="sm"
              lineHeight={20}
              weight="semiBold"
              style={{ alignSelf: "center" }}
              capitalize
            >
              {payment_frequency_text || ""}
            </RText>
            {show_lozenge ? (
              <View style={{ flex: 1, alignSelf: "center" }}>
                <RText
                  color={lozenge_text_colour || "black"}
                  family="primary"
                  size="sm"
                  lineHeight={16}
                  weight="bold"
                  style={{
                    alignSelf: "flex-end",
                    backgroundColor:
                      lozenge_box_colour || colors.palette.rtv.yellow,
                    paddingHorizontal: 5,
                    paddingVertical: 1,
                  }}
                  uppercase
                >
                  {lozenge_text || "Best Value"}
                </RText>
              </View>
            ) : null}
          </View>
        </View>
        <View style={styles.middleContainer}>
          <RText size={"xs"} lineHeight={16} weight="semiBold" color="white">
            {description}
          </RText>
        </View>
        <View style={styles.ctaContainer}>
          <RButton
            title={cta_button_text || "Join Now"}
            fontSizeOverride={16}
            style={{ paddingVertical: 2 }}
            onPress={() => {
              setIsAuthModalOpen({
                id: id,
                name: name,
                cost: cost.toString(),
                plan_type: "normal",
                form_heading: form_heading,
                form_sub_text: form_sub_text,
              });
            }}
          />
        </View>
      </View>
      <RCorner
        size="small"
        color={show_lozenge ? lozenge_box_colour : colors.palette.rtv.yellow}
        borderTopRightRadius
      />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  item: {
    flex: 1,
  },
  planContainer: {
    ...Platform.select({
      web: {
        height: "100%",
      },
    }),
    flex: 1,
    borderWidth: 2,
    borderRadius: 10,
    borderStyle: "solid",
    paddingBottom: 16,
    paddingHorizontal: 16,
  },
  planTopContainer: {},
  middleContainer: { flex: 1, paddingVertical: 8 },
  ctaContainer: { flex: 1, justifyContent: "flex-end", paddingTop: 4 },
});
